import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';
import { DetailedStockInfo } from './types';

type GetDetailedStockArgs = {
  armador: string;
  estado: string | null;
};

type GetDetailedStockResponse = {
  state: number;
  value: DetailedStockInfo[];
};

export const getDetailedStock = async ({
  armador,
  estado,
}: GetDetailedStockArgs): Promise<DetailedStockInfo[]> => {
  try {
    const res = await apiClient.post<GetDetailedStockResponse>(
      Endpoints.DetailedStock,
      {
        armador,
        estado,
      }
    );
    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
